import { serviceMaker, methods, api } from "@/http/index.js";

export const getBroadcasterList = () =>
  serviceMaker(`/broadcaster`, methods.GET, api.NGB);
export const getChannelList = () =>
  serviceMaker(`/channel`, methods.GET, api.NGB);
export const getProductChannels = () =>
  serviceMaker(`/channelmapping`, methods.GET, api.NGB);
export const createBroadcaster = (data) =>
  serviceMaker(`/broadcaster`, methods.POST, api.NGB, data);
export const getChannelTemplate = () =>
  serviceMaker(`/channel/template`, methods.GET, api.NGB);
export const createChannel = (data) =>
  serviceMaker(`/channel`, methods.POST, api.NGB, data);
export const getChannelMappingTemplate = () =>
  serviceMaker(`/channelmapping/template`, methods.GET, api.NGB);
export const createProductMapping = (data) =>
  serviceMaker(`/channelmapping`, methods.POST, api.NGB, data);
export const getBroadcasterById = (id) =>
  serviceMaker(`/broadcaster/${id}`, methods.GET, api.NGB);
export const updateBroadcaster = (id, data) =>
  serviceMaker(`/broadcaster/${id}`, methods.PUT, api.NGB, data);
export const deleteBroadcaster = (id) =>
  serviceMaker(`/broadcaster/${id}`, methods.DELETE, api.NGB);
export const getChannelById = (id) =>
  serviceMaker(`/channel/${id}`, methods.GET, api.NGB);
export const updateChannel = (id, data) =>
  serviceMaker(`/channel/${id}`, methods.PUT, api.NGB, data);
export const deleteChannel = (id) =>
  serviceMaker(`/channel/${id}`, methods.DELETE, api.NGB);
export const getChannelMappingById = (id) =>
  serviceMaker(`/channelmapping/${id}`, methods.GET, api.NGB);
export const updateChannelMapping = (id, data) =>
  serviceMaker(`/channelmapping/${id}`, methods.PUT, api.NGB, data);
export const deleteChannelMapping = (id) =>
  serviceMaker(`/channelmapping/${id}`, methods.DELETE, api.NGB);
